import axios from 'axios';
import { graphConfig } from 'msConfig';

const createMsGraphClient = (token) => {
  return axios.create({
    baseURL: graphConfig.graphMeEndpoint,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
};

export { createMsGraphClient };
